/* eslint-disable */

import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer, DefaultRenderer } from '@googlemaps/markerclusterer';  // Use MarkerClusterer v2.x

// Locations for the map, set in the craft templates eg: online-collections/types/oralHistoriesLanding etc
const locations = window.locations[0];
console.log(locations);
// Coordinates and zoom set in craft templates
const startLat = window.startLat;
const startLong = window.startLong;
const zoom = 13;

//console.log(startLat);

const loader = new Loader({
  // Military archives google API key
  apiKey: "AIzaSyCHYhJW-qzt0jzzBm0LRhvnsGUknmzNEEE",
  version: "weekly",
  libraries: ['marker']  // Keep 'marker' library for handling markers
});


// Load the Maps API
loader.load().then(() => {
  const mapOptions = {
    center: { lat: startLat, lng: startLong },
    zoom: zoom,
    mapId: 'a18a7ca9a3d91770',
    disableDefaultUI: true,
    zoomControl: true
  };

  
  loader.importLibrary('maps').then(({ Map }) => {
    const map = new Map(document.getElementById("storymap"), mapOptions);
    
    //The map pin is generated as svg, color, shape and scale set here
    const mapPin = {
        path: 'M7 0C3.13 0 0 3.13 0 7C0 8.74 0.5 10.37 1.41 11.84C2.36 13.38 3.61 14.7 4.57 16.24C5.04 16.99 5.38 17.69 5.74 18.5C6 19.05 6.21 20 7 20C7.79 20 8 19.05 8.25 18.5C8.62 17.69 8.95 16.99 9.42 16.24C10.38 14.71 11.63 13.39 12.58 11.84C13.5 10.37 14 8.74 14 7C14 3.13 10.87 0 7 0ZM7 9.75C5.62 9.75 4.5 8.63 4.5 7.25C4.5 5.87 5.62 4.75 7 4.75C8.38 4.75 9.5 5.87 9.5 7.25C9.5 8.63 8.38 9.75 7 9.75Z',
        strokeColor: '#191919',
        fillColor: '#191919',
        fillOpacity: 1,
        scale: 1.1,
    };

    const bounds = new google.maps.LatLngBounds(); // Create LatLngBounds object

      // Create a standard Google Maps marker
      const marker = new google.maps.Marker({
        position: locations.position,
        title: locations.title,
        icon: mapPin
      });    

      // InfoWindow for each marker
      const infoWindow = new google.maps.InfoWindow({
        content: locations.info
      });

      // Add click listener to open InfoWindow
      marker.addListener('click', () => {
        //infoWindow.open(map, marker);
        const popup = document.getElementById("custom-popup");
        document.getElementById("popup-content").innerHTML = locations.info;
        popup.style.display = "block"; // Show the popup
        scrollIntoViewIfNotVisible(popup);
      });

      marker.setMap(map);
    
  });
});


$("#map-close-btn").on("click", function() {
  //console.log("close");
  document.getElementById("custom-popup").style.display = "none";
});

function scrollIntoViewIfNotVisible(target) {   
  if (target.getBoundingClientRect().top < 70) {
      target.scrollIntoView();
      scrollToTargetAdjusted(target);
  } 
}

function scrollToTargetAdjusted(element){
  var headerOffset = 137;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
       top: offsetPosition,
       behavior: "smooth"
  });
}

/* eslint-enable */